<script>

  import { createEventDispatcher } from 'svelte';
  import SvelteMarkdown from 'svelte-markdown';
  import CellOutput from "./CellOutput.svelte";
  import Editor from "./Editor.svelte";
  import Button from "./Button.svelte";
  import Spinner from "./Spinner.svelte";
  import Dropdown from './Dropdown.svelte';

  export let cell;
  export let queuePosition;
  export let now;
  
  let editing, markdownInput = cell.input;

  const dispatch = createEventDispatcher()

  const submitMarkdown = () => {
    console.log('submit');
    cell.input = markdownInput;
    editing = false;
    dispatch('update')
  }

</script>
{#if cell.type === 'markdown'}
  {#if editing} 
    <Editor bind:data={markdownInput} language='markdown' keyboardShortcuts={{
      'Ctrl-Enter': submitMarkdown,
      'Shift-Enter': submitMarkdown,
    }}/>
  {:else}
    <div on:dblclick={() => editing = true} class='markdown-container'>
      <SvelteMarkdown source={cell.input}/>
    </div>
  {/if}
{:else}
  <Editor bind:data={cell.input} language='js' keyboardShortcuts={{
      'Ctrl-Enter': () => dispatch('run'),
      'Shift-Enter': () => dispatch('run'),
    }}/>
  <CellOutput content={cell.output}/>   
{/if}
<div class='button-bar'>
  <Button on:click={() => dispatch('add')}>+</Button>

  {#if cell.type === 'markdown'}
    {#if editing} 
      <Button on:click={() => {editing=false; markdownInput = cell.input}} >{'⨯'}</Button>
      <Button
      style="background-color:var(--primary);color:var(--background);" 
      on:click={submitMarkdown}>{'✓'}</Button>
    {:else}
      <Button on:click={() => {editing = true}}> {"✎"} </Button>
    {/if}
    <Dropdown title='Markdown ▼'>
      <Button on:click={() => {cell.type = 'code'; dispatch('update')}} style='width: 100%'>Convert to code cell</Button>
    </Dropdown>
  {:else}
    {#if queuePosition == -1} 
      <Button
      style="background-color:var(--primary);color:var(--background);" 
      on:click={() =>dispatch('run')}>▶</Button>
    {:else}
      <Button
      on:click={() => dispatch('cancel')}>
        <Spinner/>
        {#if queuePosition > 0}
          {queuePosition}
        {/if}
      </Button>
    {/if}
    <Dropdown title='Code ▼'>
      <Button on:click={() => {cell.type = 'markdown'; editing = true; markdownInput = cell.input; dispatch('update')}} style='width: 100%'>Convert to markdown cell</Button>
    </Dropdown>
  {/if}

  <div style='flex-grow: 100'></div>
  {#if cell.execute_start && (cell.execute_end || queuePosition == 0)}
    <Dropdown title='{Math.round(((cell.execute_end || now) - cell.execute_start)*10)/10 }s'
      width='120' left='-70' backgroundColor='#fffe'>
      <p style='font-size: small'>
        Executed on {new Date(cell.execute_start * 1000).toISOString().slice(0, 19).replace('T', ' ')} UTC
      </p>
    </Dropdown>
  {/if}
  <Button on:click={() => dispatch('remove')} style='background-color: #fee; color: var(--foreground)'>🗑</Button>
  
</div>
<style>
  .button-bar {
    display: flex;
    flex-direction: row;
    justify-content: start;
    margin-bottom: 20px;
  }

  .markdown-container :global(p) {
    text-align: left;
  }
</style>